import DescriptionIcon from "@material-ui/icons/Description";
import Create from "views/PDF/Create";
import Delete from "views/PDF/Delete";
import Edit from "views/PDF/Edit";
import List from "views/PDF/List";

import { token } from "functions/Helper";

const pdfFee = () => {
  let views = [];

  if (token["booking.pdfs.read"] === "allowed" || token.is_admin === "True")
    views.push({
      path: "/PDFs/List",
      name: "PDFs",
      icon: DescriptionIcon,
      component: List,
      layout: "/admin"
    });

  return views;
};

const pdfFeeHidden = () => {
  let views = [];

  if (token["booking.pdfs.write"] === "allowed" || token.is_admin === "True")
    views = views.concat([
      {
        path: "/PDFs/Create",
        name: "Create PDF",
        component: Create,
        layout: "/admin"
      },
      {
        path: "/PDFs/Edit",
        name: "Edit PDF",
        component: Edit,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/PDFs/Delete",
        name: "Delete PDF",
        component: Delete,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "PDF Hidden",
        state: "pdfFeeHidden",
        hideInSidebar: true,
        views: views
      }
    ];

  return [];
};

export { pdfFee, pdfFeeHidden };
